import React from 'react';
import { FiLogOut } from 'react-icons/fi';
import '../styles/ProfileHeader.css';

// Debug control - use i.e. DEBUG && console.log("whatever") and set below const true
const DEBUG = process.env.REACT_APP_DEBUG == 'enabled';

const ProfileHeader = ({ onSignOut }) => {
  return (
    <header className="profile-header">
      <div className="logo-container">
        <img src={require('../assets/logo.png')} alt="IGEL Logo" className="logo" />
      </div>
      <div className="header-h1">
        <h1>IGEL ID Profile Management</h1>
      </div>
      <button onClick={onSignOut} className="sign-out-button">
        <FiLogOut className="icon" />
        <span>Sign Out</span>
      </button>
    </header>
  );
};

export default ProfileHeader;